import { Rating } from "@chef/components";

interface RecipeRatingProps {
  recipeId: number;
  rating: number;
  onRatingClicked?: (rating: number) => void;
  size?: number;
  readOnly?: boolean;
  allowHover?: boolean;
}

export const RecipeRating = ({
  recipeId,
  rating,
  onRatingClicked,
  size = 28,
  readOnly,
  allowHover,
}: RecipeRatingProps) => {
  return (
    <Rating
      id={`rating-${recipeId}`}
      value={rating}
      numOptions={5}
      defaultValue={0}
      size={size}
      onChange={onRatingClicked}
      allowHover={allowHover}
      readOnly={readOnly}
    />
  );
};
